import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import React from "react"
import { injectIntl } from "react-intl"
import ActionButton from "../common/button/actionbutton.component"
import PermissionProtectedWarningButton from "../common/button/PermissionProtectedWarningButton"
import ButtonWrapper from "../common/rich-text/feature-protection-wrappers/buttonProtectionWrapper.component"
import Guard, { Permissions } from "../role/Guard"

type OwnProps = {
    owingBalance: number
    invoiceBalance: number
    creditLimit: number
    buttonClassName: string
    onClickEventCallback: (e) => void
    buttonIcon: Element
    buttonLabel: Element
    isDisabled: boolean
    allowedModalMessage: Element
    deniedModalMessage: Element
    protectedFeatures?: string[]
    isReturn?: boolean
}

const CreditLimitProtectionButton = (props: OwnProps) => {
    const isOverCreditLimit = () => {
        if (props.creditLimit === 0 || props.isReturn) {
            return false
        }
        return (props.owingBalance + props.invoiceBalance > props.creditLimit)
    }

    if (props.protectedFeatures) {
        const missingAccountFeatures = props.protectedFeatures.filter(feature => !AppContext.accountFeatureIsEnabled(feature))
        if (missingAccountFeatures.length > 0) {
            return <ButtonWrapper
                protectedClassName={props.buttonClassName}
                premium={false}
                protectionRule={AppContext.accountFeatureIsEnabled(missingAccountFeatures[0])}
                redirectToAccount={true}
                className={"btn btn-success mb-2 mr-2"}
                onClick={props.onClickEventCallback}
                disabled={props.isDisabled}
            >
                {props.buttonIcon}
                {props.buttonLabel}
            </ButtonWrapper>
        }

    }
    if (isOverCreditLimit()) {
        return (
            <PermissionProtectedWarningButton
                onClickEventCallback={props.onClickEventCallback}
                buttonLabel={props.buttonLabel}
                buttonIcon={props.buttonIcon}
                buttonClassName={props.buttonClassName}
                allowedModalMessage={props.allowedModalMessage}
                deniedModalMessage={props.deniedModalMessage}
                allowedPermission={Guard.isAuthorized(Permissions.BypassUpdateCreditLimit)}
            />


        )
    } else {
        return (
            <ActionButton
                key={""}
                className={props.buttonClassName}
                onClick={props.onClickEventCallback}
                disabled={props.isDisabled}
                isLoading={false}>
                {props.buttonIcon}
                {props.buttonLabel}
            </ActionButton>
        )
    }
}

export default injectIntl(CreditLimitProtectionButton)


// WEBPACK FOOTER //
// ./src/invoice/CreditLimitProtectionButton.tsx